import { render, staticRenderFns } from "./ChoiceIcon.vue?vue&type=template&id=da3d7818&"
import script from "./ChoiceIcon.vue?vue&type=script&lang=ts&"
export * from "./ChoiceIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports